const newModel = () => {
    return {
        truongchuanQuocgiaId: null,
        //Infor-Truong
        truongId: null,
        tenTruong: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        tenMucTruongchuan: null,
        namCongNhan: null,
        phanloaiTruongchuanId: null,
        tenPhanloaiTruongchuan: null,
        phuongXaId: null,
        tenPhuongXa: null,
        quymoTruongchuanId: null,
        tenQuymoTruongchuan: null,
        namSatNhap: null,
        congLap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        gioiThieu: null,


        idKy: null,
        tenKy: null,
        //Infor-Lop
        solopTieuhoc: 0,
        solopThcs: 0,
        solopThpt: 0,
        solopGdtx: 0,
        solopGhep: 0,

        //Infor-Phong
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,

        //Infor-GiaoVien
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,

        //Infor-HocSinh
        tongsoHocsinh: 0,
        tongsoHocsinhDadinhdanh: 0,
        hocsinhNu: 0,
        hocsinhDantocThieuso: 0,
        hocsinhKhuyettat: 0,
        hocsinh6den10Y: 0,
        hocsinh11den14Y: 0,
        hocsinh15den17Y: 0,


        stt: null,

        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,

        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        xoaListHinhAnh: null,
        xoaHinhAnh: null,

        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongchuanQuocgiaId: null,
        tenTruong: null,
        truongId: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        namCongNhan: null,
        phanloaiTruongchuanId: null,
        phuongXaId: null,
        quymoTruongchuanId: null,
        // capHocId: null,
        namSatNhap: null,
        congLap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,

        idKy: null,
        //Infor-Lop
        solopTieuhoc: 0,
        solopThcs: 0,
        solopThpt: 0,
        solopGdtx: 0,
        solopGhep: 0,

        //Infor-Phong
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,

        //Infor-GiaoVien
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,

        //Infor-HocSinh
        tongsoHocsinh: 0,
        tongsoHocsinhDadinhdanh: 0,
        hocsinhNu: 0,
        hocsinhDantocThieuso: 0,
        hocsinhKhuyettat: 0,
        hocsinh6den10Y: 0,
        hocsinh11den14Y: 0,
        hocsinh15den17Y: 0,

        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        xoaListHinhAnh: null,
        xoaHinhAnh: null,

        ghiChu: null,
        gioiThieu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const fromJson = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        hieuTruong: item.hieuTruong,
        sdtHieuTruong: item.sdtHieuTruong,
        mucTruongchuanId: item.mucTruongchuanId,
        namCongNhan: item.namCongNhan,
        phanloaiTruongchuanId: item.phanloaiTruongchuanId,
        tenPhanloaiTruongchuan: item.tenPhanloaiTruongchuan,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        quymoTruongchuanId: item.quymoTruongchuanId,
        // capHocId: item.capHocId,
        namSatNhap: item.namSatNhap,
        congLap: item.congLap,
        vemisId: item.vemisId,
        namThanhLap: item.namThanhLap,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,

        idKy: item.idKy,
        tenKy: item.tenKy,
        //Infor-Lop
        solopTieuhoc: item.solopTieuhoc,
        solopThcs: item.solopThcs,
        solopThpt: item.solopThpt,
        solopGdtx: item.solopGdtx,
        solopGhep: item.solopGhep,

        //Infor-Phong
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,

        //Infor-GiaoVien
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,

        //Infor-HocSinh
        tongsoHocsinh: item.tongsoHocsinh,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinh6den10Y: item.hocsinh6den10Y,
        hocsinh11den14Y: item.hocsinh11den14Y,
        hocsinh15den17Y: item.hocsinh15den17Y,


        ghiChu: item.ghiChu,
        gioiThieu: item.gioiThieu,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        hieuTruong: item.hieuTruong,
        sdtHieuTruong: item.sdtHieuTruong,
        mucTruongchuanId: item.mucTruongchuanId,
        namCongNhan: item.namCongNhan,
        phanloaiTruongchuanId: item.phanloaiTruongchuanId,
        phuongXaId: item.phuongXaId,
        quymoTruongchuanId: item.quymoTruongchuanId,
        // capHocId: item.capHocId,
        namSatNhap: item.namSatNhap,
        congLap: item.congLap,
        vemisId: item.vemisId,
        namThanhLap: item.namThanhLap,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,

        idKy: item.idKy,
        tenKy: item.tenKy,
        //Infor-Lop
        solopTieuhoc: item.solopTieuhoc,
        solopThcs: item.solopThcs,
        solopThpt: item.solopThpt,
        solopGdtx: item.solopGdtx,
        solopGhep: item.solopGhep,

        //Infor-Phong
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,

        //Infor-GiaoVien
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,

        //Infor-HocSinh
        tongsoHocsinh: item.tongsoHocsinh,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinh6den10Y: item.hocsinh6den10Y,
        hocsinh11den14Y: item.hocsinh11den14Y,
        hocsinh15den17Y: item.hocsinh15den17Y,

        ghiChu: item.ghiChu,
        gioiThieu: item.gioiThieu,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        tenTruong: null,
        truongId: null,
        vemisId: null,
        mucTruongchuanId: null,
        quymoTruongchuanId: null,
        phanloaiTruongchuanId: null,
        congLap: null,
        // capHocId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        vemisId: item.vemisId,
        mucTruongchuanId: item.mucTruongchuanId,
        quymoTruongchuanId: item.quymoTruongchuanId,
        phanloaiTruongchuanId: item.phanloaiTruongchuanId,
        congLap: item.congLap,
        // capHocId: item.capHocId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongchuanQuocgiaId: null,
        tenTruong: null,
        truongId: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        namCongNhan: null,
        phanloaiTruongchuanId: null,
        phuongXaId: null,
        quymoTruongchuanId: null,
        // capHocId: null,
        namSatNhap: null,
        congLap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,


        idKy: null,
        solopTieuhoc: null,
        solopThcs: null,
        solopThpt: null,
        solopGdtx: null,
        solopGhep: null,
        tongsoPhong: null,
        phongKienco: null,
        phongBankienco: null,
        phongTam: null,
        tongsoGiaovien: null,
        giaovienNu: null,
        giaovienDantocThieuso: null,
        giaovienDatchuan: null,
        tongsoHocsinh: null,
        tongsoHocsinhDadinhdanh: null,
        hocsinhNu: null,
        hocsinhDantocThieuso: null,
        hocsinhKhuyettat: null,
        hocsinh6den10Y: null,
        hocsinh11den14Y: null,
        hocsinh15den17Y: null,

        ghiChu: null,
        gioiThieu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

//Customs
const reLoadDataFluctuations = (oldItem, dataFluctuations) => {
    let returnData = oldItem
    returnData.solopTieuhoc = dataFluctuations.solopTieuhoc
    returnData.solopThcs = dataFluctuations.solopThcs
    returnData.solopThpt = dataFluctuations.solopThpt
    returnData.solopGdtx = dataFluctuations.solopGdtx
    returnData.solopGhep = dataFluctuations.solopGhep
    returnData.tongsoPhong = dataFluctuations.tongsoPhong
    returnData.phongKienco = dataFluctuations.phongKienco
    returnData.phongBankienco = dataFluctuations.phongBankienco
    returnData.phongTam = dataFluctuations.phongTam
    returnData.tongsoGiaovien = dataFluctuations.tongsoGiaovien
    returnData.giaovienNu = dataFluctuations.giaovienNu
    returnData.giaovienDantocThieuso = dataFluctuations.giaovienDantocThieuso
    returnData.giaovienDatchuan = dataFluctuations.giaovienDatchuan
    returnData.tongsoHocsinh = dataFluctuations.tongsoHocsinh
    returnData.tongsoHocsinhDadinhdanh = dataFluctuations.tongsoHocsinhDadinhdanh
    returnData.hocsinhNu = dataFluctuations.hocsinhNu
    returnData.hocsinhDantocThieuso = dataFluctuations.hocsinhDantocThieuso
    returnData.hocsinhKhuyettat = dataFluctuations.hocsinhKhuyettat
    returnData.hocsinh6den10Y = dataFluctuations.hocsinh6den10Y
    returnData.hocsinh11den14Y = dataFluctuations.hocsinh11den14Y
    returnData.hocsinh15den17Y = dataFluctuations.hocsinh15den17Y
    return returnData
}

export const truongQGGD_v2Model = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
    reLoadDataFluctuations,
}


